import { render } from "./AdminOptions.vue?vue&type=template&id=77ab07bc"
import script from "./AdminOptions.vue?vue&type=script&lang=js"
export * from "./AdminOptions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__